import React from 'react';


export default ({color}) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 15 15">
      <path class="a" fill={color || '#1a9de8'} d="M353.375,63.5h-5.25c-.414,0-.625-.336-.625-.75V62a1.612,1.612,0,0,0-1.625-1.5h-4.5A1.4,1.4,0,0,0,340,62V74a1.4,1.4,0,0,0,1.375,1.5h12A1.612,1.612,0,0,0,355,74V65A1.612,1.612,0,0,0,353.375,63.5Zm.125,9.75a.867.867,0,0,1-.875.75h-10.5c-.414,0-.625-.336-.625-.75V62.75c0-.414.211-.75.625-.75h3a.867.867,0,0,1,.875.75v.75a1.4,1.4,0,0,0,1.375,1.5h5.25a.867.867,0,0,1,.875.75Zm-3.875-3.75a.75.75,0,0,1-.75.75h-3a.75.75,0,0,1,0-1.5h3A.75.75,0,0,1,349.625,69.5Z" transform="translate(-340 -60.5)"/></svg>
  )
}